export const formFields = {
    countryFilter: {
        key: 'countryFilter',
        // label: 'Select Country',
        required: false,
        placeholder: 'Select',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Advertiser </div>'
    },
    platformFilter: {
        key: 'platformFilter',
        // label: 'Select Platform',
        required: false,
        placeholder: 'Select',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Advertiser </div>'
    },
    agencyFilter: {
        key: 'agencyFilter',
        // label: 'Select Country',
        required: false,
        placeholder: 'Search & Single select',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Agency </div>'
    },
    advertiserFilter: {
        key: 'advertiserFilter',
        // label: 'Select Platform',
        required: false,
        placeholder: 'Search & Single select',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Advertiser </div>'
    },
    accountOwnerFilter: {
        key: 'accountOwnerFilter',
        // label: 'Select Platform',
        required: false,
        placeholder: 'Search & Single select',
        displayLayout: 'col-md-12 mb-0',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Account Owner </div>'
    },
    platformCloneFilter: {
        key: 'platformCloneFilter',
        // label: 'Select Platform',
        required: false,
        placeholder: 'Select',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Advertiser </div>'
    },
    search: {
        key: 'search',
        type: 'string',
        label: '',
        displayLayout: 'col-md-12 m-0',
        placeholder: "Search"
    },
    startDate: {
        key: 'startDate',
        label: 'Start Date',
        required: true,
        placeholder: 'DD/MM/YYYY',
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
    },
    endDate: {
        key: 'endDate',
        label: 'End Date',
        required: true,
        placeholder: 'DD/MM/YYYY',
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
    }
};

export const accountOwnerOptions = [
    { key: -1, value: 'All' },
    { key: 0, value: 'Infomo' },
    { key: 1, value: 'Agency' },
    { key: 2, value: 'Advertiser' }
];